// Bilingual (FR/EN) aliases for canonical dish type names.
// Used by search (title-only matching for dish-type queries) and filter chips.
export const DISH_TYPE_ALIASES: Record<string, string[]> = {
  'breakfast': ['breakfast', 'déjeuner', 'brunch'],
  'main course': ['main course', 'main dish', 'plat principal'],
  'dessert': ['dessert'],
  'snack': ['snack', 'collation'],
  'appetizer': ['appetizer', 'apéritif', 'entrée'],
  'side dish': ['side dish', "plat d'accompagnement"],
  'beverage': ['beverage', 'boisson'],
  'salad': ['salad', 'salade'],
  'soup': ['soup', 'soupe'],
};

/** Meal-type filter values offered in the Filters sheet (FilterState.mealTypes). */
export type MealTypeFilterValue = 'breakfast' | 'lunch' | 'dinner' | 'dessert';

// Substrings (lowercase) that qualify a recipe's dishTypes for each filter value.
// Breakfast includes the French "déjeuner" so bilingual sources (Ricardo, K pour
// Katrine, Trois fois par jour) match as well.
const MEAL_TYPE_MATCHERS: Record<MealTypeFilterValue, string[]> = {
  breakfast: ['breakfast', 'brunch', 'déjeuner'],
  lunch: ['lunch', 'salad'],
  dinner: ['dinner', 'main'],
  dessert: ['dessert', 'sweet'],
};

/**
 * True when any of a recipe's dishTypes matches the given meal-type filter value.
 * Case-insensitive substring match. Used by the Recipes screen shelf filters.
 */
export function matchesMealType(
  dishTypes: string[] | undefined,
  mealType: MealTypeFilterValue
): boolean {
  const types = dishTypes?.map(t => t.toLowerCase()) ?? [];
  const needles = MEAL_TYPE_MATCHERS[mealType];
  return types.some(t => needles.some(n => t.includes(n)));
}
